<template>
  <div
    v-loading="true"
    class="form-dispatch"
  />
</template>
<script>
export default {
  name: 'FormNginx',
  created() {
    if (!this.$route.query.taskId) {
      return this.$router.push({
        name: 'FormMy',
        query: this.$route.query
      })
    }
    this.$api.flowTask.getDetail({
      taskId: this.$route.query.taskId
    }).then(data => {
      let name = data.task.endTime ? 'FormDone' : 'FormTodo'
      const employeeNo = $app.$store.state.workflow.userInfo.employeeNo
      const participants = Array.isArray(data.participants) ? data.participants : []
      if (!participants.find(item => item.userId === employeeNo)) {
        name = 'FormMy'
      }
      this.$router.push({
        name,
        query: {
          ...this.$route.query,
          processInstanceId: data.task.processInstanceId,
          modelKey: data.task.modelKey,
          nodeId: data.task.taskDefKey
        }
      })
    }).catch(() => {
      this.$router.push({
        name: 'FormMy',
        query: this.$route.query
      })
    })
  }
}
</script>
<style lang="scss">
.form-dispatch {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>
